export class AlertConstants {
  static successTimeout = 4000;
  static errorTimeout = 4000;
  static snackbarTransition = 750;
}
